import { Badge, Box, FieldSet, Heading, InfoIcon, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { assertNever } from '@wix/seo-common-core';
import React from 'react';
import { BiCtaNames } from '../../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../../hooks/use-open-article-by-editor-host';
import { useSessionInfoContext } from '../../../../../hooks/use-session-info-context';
import { ContrastRatioLevel } from '../../types';
export const RatioDisplay = _ref => {
  let {
    index,
    status,
    ratio,
    contrastRatioLevel: ratioLevel,
    isGeneric
  } = _ref;
  const {
    locale
  } = useSessionInfoContext();
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    capabilities,
    editorHost
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const ratioText = `${new Intl.NumberFormat(locale, {
    maximumSignificantDigits: 2
  }).format(ratio)}:1`;
  const tooltipContent = [t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info'), t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.fail'), t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.aa')].join('\n\n');
  const openLearnMore = () => {
    openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-color-contrast-help');
    biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.LearnAboutColorContrastRequirements,
      index,
      status: status ? ElementStatus.Passed : ElementStatus.Failed
    });
  };
  return /*#__PURE__*/React.createElement(FieldSet, {
    alignment: "center",
    columns: "auto 28px",
    legend: t('accessibility-wizard.rules-list.color-contrast.ratio.label'),
    legendPlacement: "top",
    legendSize: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    verticalAlign: "middle"
  }, isGeneric ? /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, ratioText) : /*#__PURE__*/React.createElement(Heading, {
    size: "small"
  }, ratioText), ratioLevel === ContrastRatioLevel.Fail ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralDanger",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.fail')) : ratioLevel === ContrastRatioLevel.AA ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralSuccess",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.pass')) : ratioLevel === ContrastRatioLevel.AAA ? /*#__PURE__*/React.createElement(Badge, {
    size: "tiny",
    skin: "neutralSuccess",
    uppercase: false
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.pass')) : assertNever(ratioLevel)), /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    skin: compactPanelChrome ? 'dark' : undefined,
    underline: "always",
    weight: "thin",
    onClick: openLearnMore
  }, t('accessibility-wizard.rules-list.color-contrast.ratio.tooltip.info.learn-more'))), /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    content: tooltipContent,
    size: "small",
    tooltipProps: {
      maxWidth: '264px',
      onShow: () => biLogger.taskElementCtaClick({
        ctaName: BiCtaNames.ColorContrastRatioInfo,
        index,
        status: status ? ElementStatus.Passed : ElementStatus.Failed
      })
    }
  })));
};
//# sourceMappingURL=ratio-display.js.map